import client from './client';

export const getStatus     = ()     => client.get('/billing/status');
export const createCheckout = (plan) => client.post(`/billing/checkout/${plan}`);
export const createPortal  = ()     => client.post('/billing/portal');
export const changePlan    = (plan) => client.post('/billing/change-plan', { plan });
